import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_USERNAME = "empty_username";
export const ERROR_EMPTY_PASSWORD = "empty_password";
export const ERROR_PASSWORDS_NOT_MATCH = "passwords_not_match";
export const ERROR_EMPTY_ROLE = "empty_role";

export default formWithMessages(props => {
  const { user, onSave, disabled } = props;

  return (
    <Form
      formProps={{
        id: `user-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...props.messagesProps}
      fields={{
        username: {
          uiProps: {
            type: "text",
            placeholder: "Username",
            autoFocus: true,
            maxLength: 100,
          },
          position: 2,
          initialValue: user.username,
          label: "Username",
        },
        password: {
          uiProps: {
            type: "password",
            placeholder: "Password",
            maxLength: 100,
          },
          position: 3,
          initialValue: "",
          label: "Password",
        },
        repeatPassword: {
          uiProps: {
            type: "password",
            placeholder: "Repeat password",
            maxLength: 100,
          },
          position: 4,
          initialValue: "",
          label: "Repeat password",
        },
        role: {
          uiProps: {
            type: "select",
            options: [
              { id: "ADMIN", name: "ADMIN" },
              { id: "TECH", name: "TECH" },
            ],
          },
          position: 5,
          initialValue: "-1",
          label: "Role",
        },
        enabled: {
          uiProps: {
            type: "checkbox",
          },
          position: 6,
          initialValue: user.enabled,
          label: "Enabled ",
          hoverHelp: () =>
            "Uncheck this box to disable this account. This account will not be able to log in unless re-enabled.",
        },
      }}
      validation={formData => {
        if (!formData.username) return ERROR_EMPTY_USERNAME;
        if (!formData.password) return ERROR_EMPTY_PASSWORD;
        if (!formData.role || formData.role < 0) return ERROR_EMPTY_ROLE;
        if (formData.password !== formData.repeatPassword)
          return ERROR_PASSWORDS_NOT_MATCH;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_USERNAME]: "Username can't be empty",
        [ERROR_EMPTY_PASSWORD]: "Password can't be empty",
        [ERROR_PASSWORDS_NOT_MATCH]: "Passwords don't match",
        [ERROR_EMPTY_ROLE]: "Select a valid role value",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/User.js